import classnames from 'classnames';
import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

import styles from './TableRow.module.scss';
import { TableRowProps } from './TableRow.types';

export const TableRow = forwardRef<HTMLAnchorElement, TableRowProps>(
  (
    {
      className,
      isClickable,
      isSelected,
      isSubRow,
      isCollapsed,
      color,
      disabled,
      onKeyUp,
      onClick,
      to,
      draggable,
      ...props
    },
    ref
  ) => {
    return (
      <Link
        to={!disabled && to ? to : 'javascript:void(0)'}
        tabIndex={!disabled && (to || isClickable) ? 0 : -1}
        className={classnames(styles.container, className, color && styles[color], {
          [styles.clickable]: isClickable || !!to,
          [styles.selected]: isSelected,
          [styles.subRow]: isSubRow,
          [styles.collapsed]: isCollapsed,
          [styles.disabled]: disabled,
        })}
        onKeyUp={event => {
          if (event.key === 'Enter') {
            if (disabled) return event.preventDefault();
            if (!to) event.preventDefault();
            onKeyUp?.(event);
          }
        }}
        onClick={event => {
          if (disabled) return event.preventDefault();
          const target = event.target as HTMLElement;
          if (
            target.matches(
              "button:not([data-role='tr']), button:not([data-role='tr']) *, a:not([data-role='tr']), a:not([data-role='tr']) *"
            )
          )
            return event.preventDefault();
          if (!to) event.preventDefault();
          onClick?.(event);
        }}
        draggable={!disabled && !!to ? draggable : false}
        data-role="tr"
        {...props}
        ref={ref}
      />
    );
  }
);
